import { useGlobalConfigsStore } from "@/storeModules/globalConfigs/globalConfigs";
import { clearLocalStorage } from "./localStorage";

export function mimicLogoutWithoutRedirect() {
  console.log("mimicLogoutWithoutRedirect");
  const globalConfigStore = useGlobalConfigsStore();
  globalConfigStore.isAuth = false;
  console.log("mimicLogoutWithoutRedirect --> isAuth = false");
  globalConfigStore.session = "";
  console.log("mimicLogoutWithoutRedirect --> session = ''");
  clearLocalStorage();
}
